import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllTodosWithTask } from "../../Api/Todo/TodoApi";
import { mapTodoTitles } from "../Types/Todo/TodoInterface";

export const getAllTodoData = createAsyncThunk(
    'getAllTodoData',
    async (_, { rejectWithValue }) => {
      try {
        const allTodos = await getAllTodosWithTask();
  
        if (allTodos.status) {
          
          return mapTodoTitles(allTodos.body['data']);
        } else {
          // If the API returns a failure status, return the error message
          return rejectWithValue(allTodos.error);
        }
      } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all Todos');
      }
    }
  );